export default __webpack_public_path__ + "static/media/banner_private_label_1.b0cb3fcd.jpg";